import { Link, SignupForm, useRouter, useStore } from '@/core'
import { GoogleButton } from '@c/auth-app/google-button'
import { MicrosoftButton } from '@c/auth-app/microsoft-button'
import { CompanyDoesNotExistModal } from '@c/onboarding-app/company-does-not-exist-modal'
import { useTranslation } from 'react-i18next'
import authStyles from '@c/auth-layout/style.module.less'

const TermsAndConditionsLabel = () => {
  const { t } = useTranslation()

  return (
    <>
      {t('auth.signupWithEmailPage.terms.agree_text')}{' '}
      <Link name="termsOfUse" target="_blank">
        {t('auth.signupWithEmailPage.terms.terms_link')}
      </Link>{' '}
      {t('auth.signupWithEmailPage.terms.and')}{' '}
      <Link name="privacyPolicy" target="_blank">
        {t('auth.signupWithEmailPage.terms.privacy_link')}
      </Link>
    </>
  )
}

export const SignupPage = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const store = useStore()
  const [, setModal] = store.use(['modal'])

  return (
    <>
      <div className={authStyles.formHeader}>
        <h1>{t('auth.signupPage.title')}</h1>
        <p>Choose how you want to join your company.</p>
      </div>

      <CompanyDoesNotExistModal />
      <GoogleButton />
      <MicrosoftButton />

      <div style={{ margin: '1.5rem 0', display: 'flex', alignItems: 'center', gap: '16px' }}>
        <div style={{ flex: 1, height: '1px', background: '#D9E8F5' }} />
        <span style={{ fontSize: '13px', color: '#6B7B8D', fontWeight: 500 }}>OR</span>
        <div style={{ flex: 1, height: '1px', background: '#D9E8F5' }} />
      </div>

      <SignupForm
        onError={(err) => {
          if (err.fieldErrors?.email?.includes('Company does not exist')) {
            setModal('company-does-not-exist')
            return
          }
          throw err
        }}
        onSuccess={(res) => {
          router.push({ name: 'verifyEmail', queries: { userId: res.userId, email: store.get(['forms', 'signup', 'values', 'email']) } })
        }}
        termsLabel={<TermsAndConditionsLabel />}
      />

      <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
        {/* <p style={{ fontSize: '14px' }}>
          <Link name="nonprofitSignup" style={{ color: '#2B9FE8' }}>
            {t('auth.signupPage.nonprofit_signup_link')}
          </Link>
        </p> */}
        <p style={{ fontSize: '14px', marginTop: '0.5rem' }}>
          Company not on Purposely?{' '}
          <Link name="bookDemo" style={{ color: '#2B9FE8' }}>
            Book a demo
          </Link>
        </p>
      </div>
    </>
  )
}
